import { IconProps } from './types';

export const HouseIcon = ({ title = 'House Icon', ...props }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" fill="none" viewBox="0 0 38 38" {...props}>
        <title>{title}</title>
        <path
            fill="#0A2F73"
            d="M26.213 3.836c0-.439.359-.794.801-.794h4.008c.442 0 .801.355.801.794v8.74a.8.8 0 0 1-.802.794h-4.007a.8.8 0 0 1-.801-.794z"
        ></path>
        <path
            fill="#0A2F73"
            d="M17.866 5.754 6.646 16.877c-.3.298-.47.703-.47 1.124v18.41c0 .878.718 1.589 1.604 1.589h22.44c.885 0 1.603-.711 1.603-1.589v-18.41c0-.421-.169-.826-.47-1.124L20.133 5.754a1.613 1.613 0 0 0-2.267 0"
        ></path>
        <path
            fill="#FB0"
            fillRule="evenodd"
            d="M18.433.233a.806.806 0 0 1 1.134 0l18.198 18.04a.79.79 0 0 1 0 1.124l-2.267 2.247a.806.806 0 0 1-1.133 0L19.567 6.974a.806.806 0 0 0-1.134 0L3.635 21.644a.806.806 0 0 1-1.133 0L.235 19.397a.79.79 0 0 1 0-1.123z"
            clipRule="evenodd"
        ></path>
        <path fill="#FB0" d="M13.39 20.52c0-.438.358-.794.801-.794h9.617c.443 0 .802.356.802.795V38H13.39z"></path>
        <path
            fill="#0A2F73"
            d="M23.007 28.863c0 .658-.538 1.192-1.202 1.192a1.197 1.197 0 0 1-1.202-1.192c0-.658.538-1.192 1.202-1.192s1.202.534 1.202 1.192"
        ></path>
    </svg>
);
